export function getByFieldName<O extends object, K extends keyof O & string>(params: O[], key: K): O[K][] {
    return params.map(value => value[key]);
}
